
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/community/groups/[groupId]/pending-invites",
      function () {
        return require("private-next-pages/admin/community/groups/[groupId]/pending-invites.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/community/groups/[groupId]/pending-invites"])
      });
    }
  